var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[_c('div',{attrs:{"id":"qrcode"}}),_c('remote-js',{attrs:{"jsUrl":_vm.jsUrl,"js-load-call-back":_vm.loadRongJs}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }